import React from "react"
import { Link } from "gatsby"
import Title from "../Globals/Title"

const Info = () => {
  return (
    <section className="py-5">
      <div className="container">
        <Title title="Our story" />
        <div className="row">
          <div className="col-10 col-sm-8 mx-auto text-center">
            <p className="lead text-muted mb-5">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi,
              dolore eligendi eos et excepturi nihil officiis quae quis quo
              unde? Cumque ducimus eveniet impedit ipsa, repellat voluptatem!
              Adipisci atque exercitationem fuga minima quidem quis quos
              recusandae reprehenderit, sunt velit. Aliquid debitis dolores
              excepturi hic itaque laborum nulla, perferendis saepe. Dolorum in
              minima quos recusandae! Ex id, magnam. Architecto deserunt dolorem
              eius explicabo facere in maiores, neque nisi perspiciatis porro
              quo sapiente sunt totam voluptate voluptatum. Aliquid animi atque,
              consequatur debitis dolorum ducimus earum eos esse fugit hic iure
              magnam minima, nesciunt odit perferendis provident, ratione
              repudiandae sapiente tempora ullam veniam?
            </p>
            <Link to="/about/">
              <button className="btn text-uppercase btn-yellow">
                About Page
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Info
